import { isEqual } from 'lodash'
import usePermissionsList from '@hooks/usePermissionsList'
import IStoreState from '@store/IStoreState'
import { useSelector } from 'react-redux'

function useShouldDisplayProviderScopes({
  scope,
  providerScope,
}: {
  scope: string[]
  providerScope: string[]
}) {
  const activeCountry = useSelector(
    (state: IStoreState) => state.providers.selectedProvider.country,
  )
  const permissionsList = usePermissionsList(scope)
  const clientPermissionsList = usePermissionsList(providerScope)

  const scopesAreEqual = isEqual(permissionsList, clientPermissionsList)
  const shouldHideForCountry = ['de', 'fr', 'nl', 'es', 'it'].includes(activeCountry) // context: https://truelayer.slack.com/archives/C02E0R86XT5/p1745503369255899

  return !scopesAreEqual && !shouldHideForCountry
}

export default useShouldDisplayProviderScopes
